module.exports = __webpack_public_path__ + "img/clicks-logo.c3ff3db0.jpg";